import { KlaviyoPopupAdapter } from '@/components/popup-logic/adapters/klaviyo';
import { Popup } from '@/components/popup-logic/popup';

type KlaviyoIDs = {
  displayName: string;
  desktop: string;
  mobile: string;
};

const urlWhitelist = [
  'products/orogold',
  'products/jelessi',
  'products/introstem',
  'products/zerogravity',
  'products/vine-vera',
  'collections/introstem',
  'collections/vine-vera',
  'collections/jelessi',
  'collections/zero-gravity',
  'collections/orogold',
];

const urlBlacklist: string[] = [];

function shouldRun(): boolean {
  // Only not run on Medispa pages
  if (
    document.body.classList.contains('template-medispa-v2') ||
    document.body.classList.contains('template-medispa-overview-v2')
  ) {
    return false;
  }

  // Check if current URL is in blacklist
  for (const url of urlBlacklist) {
    if (window.location.href.includes(url)) {
      return false;
    }
  }

  // Don't run on voucher page
  if (window.location.href.includes('/products/glamour-beauty-affairs-700-voucher')) {
    return false;
  }

  // If there's no whitelist configured, allow (blacklist still has precedence).
  if (urlWhitelist.length === 0) {
    return true;
  }

  // Check if current URL is in whitelist
  for (const url of urlWhitelist) {
    if (window.location.href.includes(url)) {
      return true;
    }
  }

  return false;
}

export default function addDefinitions(): boolean {
  try {
    // Only run on Medispa pages
    if (!shouldRun()) {
      return false;
    }

    // Map of popup IDs to their desktop and mobile variants
    // Key is the market code (e.g. "zh-hans", "en"). "default" is used as a fallback
    const klaviyoFormMap = new Map<string, KlaviyoIDs>([
      [
        'zh-hans',
        {
          displayName: 'One-step email & Whatsapp - SC (25% off Selected Brands)',
          desktop: 'T8JqfE',
          mobile: 'XQPLhB',
        },
      ],
      [
        'en',
        {
          displayName: 'One-step email & Whatsapp - EN (25% off Selected Brands)',
          desktop: 'T5vak4',
          mobile: 'UXeYxP',
        },
      ],
      [
        'default',
        {
          displayName: 'One-step email & Whatsapp - TC (25% off Selected Brands)',
          desktop: 'XDyfsi',
          mobile: 'Yf4MBa',
        },
      ],
    ]);

    const currentMarket = window.Shopify.routes.root.replace(/\//g, '');

    const klaviyoID = klaviyoFormMap.get(currentMarket) || klaviyoFormMap.get('default')!;

    const deviceType = matchMedia('(pointer: fine)').matches ? 'desktop' : 'mobile';

    const adapter = new KlaviyoPopupAdapter({ id: klaviyoID[deviceType] });
    const popup = new Popup(adapter, {
      id: klaviyoID[deviceType],
      displayName: klaviyoID.displayName,
    });

    window.popupMonitor.addPopup(popup);

    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
}
